export default "__VITE_ASSET__DAYRZNi4__"